import { useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import SkipToContent from "@/components/SkipToContent";
import NavV2 from "@/components/homev2/NavV2";
import HeroV2 from "@/components/homev2/HeroV2";
import CredibilityV2 from "@/components/homev2/CredibilityV2";
import CreativeV2 from "@/components/homev2/CreativeV2";
import EcosystemV2 from "@/components/homev2/EcosystemV2";
import DifferentiationV2 from "@/components/homev2/DifferentiationV2";
import GuaranteeV2 from "@/components/homev2/GuaranteeV2";
import TestimonialsV2 from "@/components/homev2/TestimonialsV2";
import FounderV2 from "@/components/homev2/FounderV2";
import FaqV2 from "@/components/homev2/FaqV2";
import LeadFormV2 from "@/components/homev2/LeadFormV2";
import FooterV2 from "@/components/homev2/FooterV2";

import { captureUtmParams } from "@/lib/analytics";

/**
 * Nouvelle version de la page d'accueil — environnement de prévisualisation.
 * Accessible à /accueil-v2. La page d'accueil en production (/) n'est pas modifiée.
 */
const AccueilV2 = () => {
  useEffect(() => {
    captureUtmParams();
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "Agence 8020",
    description:
      "Agence créative et partenaire de croissance : stratégie, contenu, publicité, génération de leads, suivi et optimisation.",
    areaServed: "Québec, Canada",
    url: "https://agence8020.com",
  };

  return (
    <>
      <SEOHead
        title="Agence 80/20 | Partenaire de croissance pour entreprises de services au Québec"
        description="Agence 80/20 connecte la stratégie, le contenu, la publicité, la génération de leads et l'optimisation dans un seul écosystème de croissance. Parlons de votre entreprise."
        canonical="/accueil-v2"
        noIndex
        schemaJson={schema}
      />
      <SkipToContent />
      <div
        className="min-h-screen bg-background text-foreground"
        lang="fr-CA"
       
      >
        <NavV2 />
        <main id="main-content">
          <HeroV2 />
          <CredibilityV2 />
          {/* Section Résultats masquée jusqu'à l'intégration de résultats vérifiables. */}
          <CreativeV2 />
          <EcosystemV2 />
          <DifferentiationV2 />
          <GuaranteeV2 />
          <TestimonialsV2 />
          <FounderV2 />
          <FaqV2 />
          <LeadFormV2 />
        </main>

        <FooterV2 />
      </div>
    </>
  );
};

export default AccueilV2;
